(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    // Only run on product pages (we’ll set window.__BIS_RULES from Liquid)
    if (!window.__BIS_RULES || !window.__BIS_RULES.product) return;

    var rules = window.__BIS_RULES;

    var BIS_SELECTORS = ".NotifyBtn, .klaviyo-bis-trigger";

    function hideBIS() {
      document.querySelectorAll(BIS_SELECTORS).forEach(function (btn) {
        btn.style.setProperty("display", "none", "important");
      });
    }

    function showBIS() {
      document.querySelectorAll(BIS_SELECTORS).forEach(function (btn) {
        btn.style.removeProperty("display");
      });
    }

    function productMatchesAny(keywords) {
      var title = (rules.product.title || "").toLowerCase();
      var handle = (rules.product.handle || "").toLowerCase();
      return keywords.some(function (k) {
        k = String(k || "").toLowerCase();
        return title.includes(k) || handle.includes(k);
      });
    }

    function getColorOptionIndex() {
      var opts = rules.product.options || [];
      var idx = -1;
      opts.forEach(function (optName, i) {
        var n = String(optName || "").toLowerCase();
        if (n === "color" || n === "colour" || n.includes("color") || n.includes("colour")) {
          idx = i;
        }
      });
      return idx;
    }

    function getSelectedVariant() {
      var product = rules.product;
      if (!product || !product.variants) return null;

      // Prefer URL ?variant=
      try {
        var params = new URLSearchParams(window.location.search);
        var vid = params.get("variant");
        if (vid) {
          var found = product.variants.find(function (v) {
            return String(v.id) === String(vid);
          });
          if (found) return found;
        }
      } catch (e) {}

      // Fallback to Liquid-provided current variant id
      if (rules.currentVariantId) {
        var found2 = product.variants.find(function (v) {
          return String(v.id) === String(rules.currentVariantId);
        });
        if (found2) return found2;
      }

      return product.variants[0] || null;
    }

    function includesAny(haystack, list) {
    haystack = (haystack || "").toLowerCase();
    return list.some(function (w) {
        return haystack.includes(String(w || "").toLowerCase());
    });
    }

    function evaluateBISVisibility() {
    var title = (rules.product.title || "").toLowerCase();
    var handle = (rules.product.handle || "").toLowerCase();
    var text = title + " " + handle;

    // 1) Blocked styles: never show
    if (includesAny(text, rules.blockedStyleKeywords)) {
        hideBIS();
        return;
    }

    // 2) Hope / Mayfair: only show on allowed colors
    if (includesAny(text, rules.gatedStyleKeywords)) {
        var allowed = includesAny(text, rules.allowedColors);
        if (allowed) showBIS();
        else hideBIS();
        return;
    }

    // 3) Everything else: allow
    showBIS();
    }


    // Observe DOM (Klaviyo injects the trigger later)
    var observer = new MutationObserver(function () {
      evaluateBISVisibility();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Re-check on common variant-change patterns
    document.addEventListener("variant:change", evaluateBISVisibility);
    document.addEventListener("variantChange", evaluateBISVisibility);
    document.addEventListener("change", function (e) {
      if (e.target && (e.target.matches("select") || e.target.matches('input[type="radio"]'))) {
        evaluateBISVisibility();
      }
    });

    // Initial run
    evaluateBISVisibility();
  });
})();
